var NodeUtils;
((NodeUtils2) => {
  let FindNodesFilterResult;
  ((FindNodesFilterResult2) => {
    FindNodesFilterResult2["MATCH_AND_CONTINUE"] = "MATCH_AND_CONTINUE";
    FindNodesFilterResult2["MATCH_AND_SKIP_CHILDREN"] = "MATCH_AND_SKIP_CHILDREN";
    FindNodesFilterResult2["NO_MATCH_AND_CONTINUE"] = "NO_MATCH_AND_CONTINUE";
    FindNodesFilterResult2["NO_MATCH_AND_SKIP_CHILDREN"] = "NO_MATCH_AND_SKIP_CHILDREN";
  })(FindNodesFilterResult = NodeUtils2.FindNodesFilterResult || (NodeUtils2.FindNodesFilterResult = {}));
  NodeUtils2.removeAllChildNode = (node) => {
    while (node?.firstChild) {
      node.firstChild.remove();
    }
  };
  NodeUtils2.removeAllChildNodeAndAppend = (node, newNode) => {
    (0, NodeUtils2.removeAllChildNode)(node);
    if (Array.isArray(newNode)) {
      newNode.forEach((it) => node.appendChild(it));
      return;
    }
    node.appendChild(newNode);
  };
  NodeUtils2.appendChild = (parentNode, childNode) => {
    return parentNode.appendChild(childNode);
  };
  NodeUtils2.replaceNode = (targetNode, newNode) => {
    return targetNode.parentNode?.replaceChild(newNode, targetNode);
  };
  NodeUtils2.insertAfter = (targetNode, newNode) => {
    return targetNode.parentNode?.insertBefore(newNode, targetNode.nextSibling);
  };
  NodeUtils2.cloneNode = (element, deep) => {
    return element.cloneNode(deep ?? false);
  };
  NodeUtils2.findNodes = (rootNode, filter) => {
    const foundNodes = [];
    function traverse(node) {
      if (!node) {
        return;
      }
      node.childNodes.forEach((child) => {
        const result = filter(child);
        if (result === "MATCH_AND_CONTINUE" /* MATCH_AND_CONTINUE */ || result === "MATCH_AND_SKIP_CHILDREN" /* MATCH_AND_SKIP_CHILDREN */) {
          foundNodes.push(child);
        }
        if (result === "MATCH_AND_CONTINUE" /* MATCH_AND_CONTINUE */ || result === "NO_MATCH_AND_CONTINUE" /* NO_MATCH_AND_CONTINUE */) {
          traverse(child);
        }
      });
    }
    traverse(rootNode);
    return foundNodes;
  };
})(NodeUtils || (NodeUtils = {}));
export {
  NodeUtils
};
//# sourceMappingURL=NodeUtils.js.map
